import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Attach JWT token to every Axios request if exists
  axios.defaults.withCredentials = true; // since tokens stored in httpOnly cookies

  // ✅ Check login status on page refresh
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get("/auth/me"); // backend route: verify access token
        setUser(res.data.user);
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  // ✅ Login function
  const login = async (email, password) => {
    const res = await axios.post("/auth/login", { email, password });
    setUser(res.data.user);
  };

  // ✅ Logout function
  const logout = async () => {
    await axios.post("/auth/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ Hook for easy usage inside components
export const useAuth = () => {
  return useContext(AuthContext);
};
